<script setup lang="ts">
import { isMobile } from '@/helpers/detectDevice'

interface Props {
  position?: string
  rect?: string
  top?: string | null
  right?: string | null
}
withDefaults(defineProps<Props>(), {
  position: 'absolute',
  rect: '20px',
  top: null,
  right: null
})
const emit = defineEmits<{
  (e: 'close'): void
}>()

const close = () => emit('close')
</script>

<template>
  <div
    v-keydown:Escape="close"
    class="close-button-wrapper pointer"
    :style="
      {
        position,
        right: right || (isMobile() ? '20px' : '32px'),
        top: top || (isMobile() ? '20px' : '24px')
      } as any
    "
    @click.stop="close"
  >
    <img
      class="close-button"
      src="@/assets/icons/close.svg"
      :style="{ width: rect, height: rect }"
    />
  </div>
</template>

<style scoped>
.close-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.15s ease;
}

.close-button-wrapper:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
</style>
